import type { FC } from 'react'
import styled from 'styled-components'

import PillButton from '@/components/DEPRECATED_UI/PillButton'
import type { Step } from '@/components/GuideMe'

interface Props {
  step: Step
}

const Container = styled.div``

const Evidence = styled.img`
  &:hover {
    cursor: pointer;
  }
`

function renderText(text: string) {
  const newLines = text.split('\n')

  return newLines.map(line => <p>{line}</p>)
}

const StepItem: FC<Props> = ({
  step: { title, description, callToAction, supportingDocuments },
}) => {
  return (
    <Container>
      <h2>{title}</h2>
      <div>{renderText(description)}</div>

      {callToAction && (
        <div>
          <PillButton onClick={() => window.open(callToAction.url, '_blank')}>
            {callToAction.text ?? 'View'}
          </PillButton>
        </div>
      )}

      {supportingDocuments && (
        <div>
          {supportingDocuments.map((document, index) => (
            <>
              <Evidence
                onClick={() => window.open(document.fileName, '_blank')}
                src={document.thumbnail}
                alt={`${document.specifiedType} document`}
              />
              <strong>
                <p>
                  Document {index + 1} ({document.specifiedType})
                </p>
              </strong>
            </>
          ))}
        </div>
      )}
    </Container>
  )
}

export default StepItem
